import divisionsReducer from './division';
export * from './division';

export default { divisions: divisionsReducer };
